// Components
import {
  FormControl,
  FormField,
  FormItem,
  SelectFechaNacimiento,
} from '../../../../atoms';

// Fuctions
import { useFormContext } from 'react-hook-form';

export function FieldFechaNacimiento({ index, isPasoEmision = false }) {
  const form = useFormContext();

  return (
    <div className="flex flex-col lg:space-y-1">
      <span className="text-sm lg:text-base text-primary">
        Fecha de nacimiento <span className="text-danger">*</span>
      </span>

      <FormField
        control={form.control}
        name={`dependientes.${index}.fechaNacimiento`}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <SelectFechaNacimiento
                setValue={field.onChange}
                value={field.value}
                isDisabled={isPasoEmision}
                alignError="left"
                msgError={
                  form.formState.errors?.dependientes?.[index]?.fechaNacimiento
                    ?.message
                }
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
}
